// extracted by mini-css-extract-plugin
export default {"wrapper":"CommonPane_wrapper__5Es3R"};